import React, {useEffect, useState} from "react";
import "./eventTemplateCard.sass";
import {useStores} from "../../../stores/useStores";
import {useTranslation} from "react-i18next";
import ButtonIcon from "../button/buttonIcon";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";
import Tag from "../tag/tag";
import TitleCard from "../engageEventTemplateCard/titleCard";

export interface IEventTemplateCardProps {
  /**
   * Image source for rendering the images
   */
  imageSrc?: string;
  /**
   * Description of template.
   */
  description: string;
  /**
   * Image ID.
   */
  imageId: string;
  /**
   * Template title.
   */
  title: string;
  /**
   * Is this template considered new
   */
  isNew: boolean;
  /**
   * Function to call when the use template button clicked.
   */
  onClick: (templateId: string) => void;
  /**
   * Template ID
   */
  templateId: string;
}

const EventTemplateCard: React.FC<IEventTemplateCardProps> = ({
  imageSrc,
  description,
  imageId,
  title,
  isNew,
  onClick,
  templateId
}) => {
  const {t} = useTranslation("eventTemplate");

  const {
    domainStore: {eventCatalogueDomainStore}
  } = useStores();
  const [src, setSrc] = useState(imageSrc);

  useEffect(() => {
    let abortController = new AbortController();
    if (!src) {
      eventCatalogueDomainStore
        .getEventTemplateImage(imageId, 400, 350, undefined, abortController)
        .then((result: string) => {
          setSrc(result);
        });
    }

    return () => abortController.abort(); //called when the component is unmounted.
  }, [eventCatalogueDomainStore, imageId, src]);

  const maxDescriptionLength = 160;
  description =
    description.length > maxDescriptionLength
      ? description.substring(0, maxDescriptionLength) + "..."
      : description;

  return (
    <div className="event-template-card col-4">
      {imageId ? (
        <div className="card">
          <div className="cover ">
            <div className="image">
              {src ? (
                <img src={src} alt="" loading="lazy" />
              ) : (
                <Icon source={IconSource.image} />
              )}
            </div>
            {isNew && (
              <Tag type="success" text={t("eventTemplate:labels.new")} />
            )}
            <div className="title ">
              <div>{title}</div>
            </div>
          </div>
          <div className="text ">
            <span>{description}</span>
            <div>
              <ButtonIcon type="secondary" onClick={() => onClick(templateId)}>
                {t("eventTemplate:labels.useTemplate")}
              </ButtonIcon>
            </div>
          </div>
        </div>
      ) : (
        <TitleCard
          title={title}
          onClick={() => onClick(templateId)}
        ></TitleCard>
      )}
    </div>
  );
};

export default EventTemplateCard;
